import React from "react";
import styles from "./index.module.scss";
import { Radio } from "antd";

function GenderPicker({onChange, value}) {

  const consultationModes = [
    { name: "Male", icon: <i class="fal fa-mars"></i> },
    { name: "Female", icon: <i class="fal fa-venus"></i> },
    { name: "Other", icon: <i class="fal fa-transgender"></i> },
  ];

  const checkIfActive = (flag)=>{
    return value==flag
  }

  return (
    <div className={`${styles.consultationModePickerWrap} ${styles.genderPickerWrap}`}>
     { consultationModes.map((each, key)=>{
        return(
            <div onClick={()=>{onChange(each?.name)}} className={`${styles.pickerItem} ${checkIfActive(each?.name)&&styles.pickerItemActive}`}>
                <Radio checked={checkIfActive(each?.name)}/>
                {
                    each?.icon
                }
                <label>{each?.name}</label>
            </div>
        )
     })}
    </div>
  );
}

export default GenderPicker;
